<div class="integrations-search-company">
    <!-- Staged card (after a pick OR pre-filled selection) -->
    <div
        *ngIf="selectedCompany as selected; else searchInput"
        class="integrations-search-company__staged-card"
    >
        <span class="integrations-search-company__staged-name">{{ selected.name }}</span>
        <ham-button
            *ngIf="!locked"
            variant="transparent"
            size="xs"
            (buttonClick)="onChangeSelection()"
        >
            {{ 'aumico_button_change' | i18next }}
        </ham-button>
    </div>

    <!-- Search input + dropdown (default state) -->
    <ng-template #searchInput>
    <!--
        hamInput directive wraps this <input> in `.ham-input > .input-wrapper`
        and adds its own X clear button. We bind [ngModel]/(ngModelChange) the
        same way; the directive acts as the ControlValueAccessor and routes value
        changes through Angular forms. Clearing via the directive's X fires
        (ngModelChange) with '', which we handle in onSearchChange.
    -->
    <input
        hamInput
        type="text"
        autocomplete="off"
        [ngModel]="searchTerm"
        (ngModelChange)="onSearchChange($event)"
        (focus)="onSearchFocus()"
        (blur)="onSearchBlur()"
        [placeholder]="placeholder ? placeholder : ('aumico_mapping_search_placeholder' | i18next)"
    />

    <p
        *ngIf="!showDropdown && searchTerm.length > 0 && searchTerm.length < 3"
        class="integrations-search-company__hint"
    >
        {{ 'aumico_mapping_search_hint_min_chars' | i18next }}
    </p>

    <ng-container *ngIf="showDropdown && (searchResults$ | async) as results">
        <div
            *ngIf="!hasError"
            class="integrations-search-company__dropdown"
            (mousedown)="$event.preventDefault()"
        >
            <div *ngIf="isLoading" class="integrations-search-company__loading">
                <span class="integrations-search-company__spinner"></span>
                {{ 'aumico_mapping_search_loading' | i18next }}
            </div>

            <ng-container *ngIf="!isLoading">
                <div
                    *ngIf="results !== null && results.length > 0"
                    class="integrations-search-company__dropdown-header"
                >
                    {{ 'aumico_mapping_search_results_count' | i18next : { count: results.length } }}
                </div>

                <button
                    *ngFor="let result of results"
                    type="button"
                    class="integrations-search-company__row"
                    (click)="onSelectSearchResult(result)"
                >
                    <span
                        class="integrations-search-company__row-name"
                        [innerHTML]="highlightMatch(result.name)"
                    ></span>
                </button>

                <p
                    *ngIf="results !== null && results.length === 0"
                    class="integrations-search-company__empty"
                >
                    {{ 'aumico_mapping_search_no_results' | i18next }}
                </p>
            </ng-container>
        </div>

        <p *ngIf="hasError" class="integrations-search-company__error">
            {{ 'aumico_mapping_search_error' | i18next }}
        </p>
    </ng-container>
    </ng-template>
</div>
